const SECURE_INBOX_PAGE = 'SECURE_INBOX_PAGE';
const APPLICATION_ELIGIBILITY_PAGE = 'APPLICATION_ELIGIBILITY_PAGE';
const ENROLLMENTS = 'ENROLLMENTS';
const ACCOUNT_ACTIVITY = 'ACCOUNT_ACTIVITY';
const RESET_PASSWORD_PAGE = 'RESET_PASSWORD_PAGE';

export const PAGE_TYPE = {
    SECURE_INBOX_PAGE,
    APPLICATION_ELIGIBILITY_PAGE,
    ENROLLMENTS,
    ACCOUNT_ACTIVITY,
    RESET_PASSWORD_PAGE,
};
